import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { Routes, rootRouteRef } from './routes';

export const recordingsPlugin = createPlugin({
  id: 'recordings',
  routes: {
    ...Routes,
  },
});

export const ConfidenceRecordingsPage = recordingsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceRecordingsPage',
    component: () =>
      import(/* webpackChunkName: "confidence-recordings" */ './Router').then(
        m => m.Router,
      ),
    mountPoint: rootRouteRef,
  }),
);
